
import React from 'react';
import styles from '../../styles/home.module.css';

function SectionTry() {
  return (
      <section className={styles.SectionTry} id="try">
        <div className={styles.InTry}>
          <h2>Izberi zdravje, zapiši si</h2>
          <div>
            <a className={styles.TryButton} href="#about">NAMESTI</a>
          </div>
        </div>
      </section>
  );
}

export default SectionTry;
